(() => {
  const storageKey = 'theme-mode';
  const root = document.documentElement;

  function setMode(isDark) {
    root.classList.toggle('dark-mode', isDark);
    if (document.body) document.body.classList.toggle('dark-mode', isDark);

    const toggle = document.querySelector('.dark-mode-toggle');
    if (!toggle) return;

    toggle.setAttribute('aria-pressed', String(isDark));
    toggle.setAttribute('aria-label', isDark ? 'Disable dark mode' : 'Enable dark mode');
  }

  function getSavedMode() {
    try {
      return localStorage.getItem(storageKey);
    } catch (error) {
      return null;
    }
  }

  function saveMode(isDark) {
    try {
      localStorage.setItem(storageKey, isDark ? 'dark' : 'light');
    } catch (error) {}
  }

  function init() {
    const toggle = document.querySelector('.dark-mode-toggle');
    const savedMode = getSavedMode();
    setMode(savedMode !== 'light');

    if (!toggle) return;

    toggle.addEventListener('click', () => {
      const isDark = !root.classList.contains('dark-mode');
      setMode(isDark);
      saveMode(isDark);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
